import React, { useId } from 'react';
import { useStoryStore } from '../../../../stores';
import { ModalRoot } from '../../../shared/Modal/ModalRoot';
import { BirthdayCard } from './Card';

const StoryView = (): React.JSX.Element | null => {
    const isVisible = useStoryStore((state) => state.isVisible);
    const closeStory = useStoryStore((state) => state.closeStory);
    const titleId = useId();

    if (!isVisible) {
        return null;
    }

    return (
        <ModalRoot
            onClose={closeStory}
            labelledBy={titleId}
            overlayClassName="birthday-card-overlay"
            dialogClassName="birthday-card"
        >
            <BirthdayCard onClose={closeStory} titleId={titleId} />
        </ModalRoot>
    );
};

export default StoryView;
